import { Component, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-overlay',
  templateUrl: './video-overlay.component.html',
  styleUrls: ['./video-overlay.component.scss']
})
export class VideoOverlayComponent {
  isOpen = false;
  videoUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  openVideo(getLink: string) {
    if (!getLink.startsWith('https://')) {
      getLink = 'https://' + getLink; // Ensure correct URL format
    }
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(getLink);
    this.isOpen = true;
  }

  closeVideo() {
    this.isOpen = false;
    this.videoUrl = null; // Remove video URL when closing to stop playback
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeVideo();
    }
  }
}
